export const CELL_WIDTH_PRICE = '132px';
export const blackTableBorder = `1px solid var(--lhds-color-ui-500)`;
export const grayTableBorder = `1px solid var(--lhds-color-ui-300)`;
